<template>
  <div>
    <span v-if="trackingNumberYun">
      <a
          v-if="trackingNumberYun"
          target="_blank"
          :href="trackingNumberYun | trackingLink"
      >
        {{ trackingNumberYun }}
      </a>
      <a href="javascript:void(0)"
      @click="() => setField({ key: 'showPackageInfo', value: true })"
      class="text-muted">
      <i class="fa fa-info-circle"/></a>
    </span>
    <br v-if="orderPackage.trackingNumber && trackingNumberYun"/>
    <span v-if="orderPackage.trackingNumber">
      <a v-if="orderPackage.trackingNumber"
        target="_blank"
        :href="orderPackage | trackingLink"
      >
        {{ orderPackage.trackingNumber }}
      </a>
      <a href="javascript:void(0)"
      @click="() => setField({ key: 'showPackageInfo', value: true })"
      class="text-muted">
      <i class="fa fa-info-circle"/></a>
    </span>
    <br/>
    <tracking-status
        :status="orderPackage.trackingStatus"
        :date="orderPackage.trackingUpdatedAt"
    />
    <modal
        :show="form.showPackageInfo"
        :close="() => setField({ key: 'showPackageInfo', value: false })"
        title="Tracking Info detail"
    >
      <div v-if="orderPackage['trackingDetails'] && orderPackage['trackingDetails'].length > 0">
        <table class="table table-striped">
          <tbody>
          <tr v-for="(item, index) in orderPackage.trackingDetails" :key="index">
            <td>{{ item }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="text-center">No tracking found</div>
      <div slot="footer">
        <div class="flex-group">
          <button type="button" class="btn btn-secondary flex-item"
                  @click="() => setField({ key: 'showPackageInfo', value: false })">
            Cancel
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>
<style scoped>
a {
  color: black;
}

a:hover {
  font-weight: 600;
}
</style>

<script>
import {mapActions, mapGetters} from "vuex";
import TrackingStatus from "@/components/Common/TrackingStatus";
import Modal from "@/components/Misc/Modal";

export default {
  name: "TrackingInfo",
  filters: {
    trackingLink(trackingInfo) {
      if (!trackingInfo) {
        return '#'
      }

      if (/yt/i.test(trackingInfo)) {
        return `https://t.17track.net/en#nums=${trackingInfo}`;
      }

      // const carrier = trackingInfo.carrierCode
      const trackingNumber = trackingInfo.trackingNumber
      // if (`${carrier}`.toUpperCase() === 'USPS') {
      //   return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNumber}`
      // }

      if (/.*GB$/.test(trackingNumber)) {
        return `https://www.royalmail.com/track-your-item#/tracking-results/${trackingNumber}`;
      }

      return `https://t.17track.net/en#nums=${trackingNumber}`
    }
  },
  components: {
    TrackingStatus,
    Modal
  },
  props: ["order", "orderPackage", "role"],
  computed: {
    ...mapGetters({
      form: "order/form",
    }),
    boDisplay() {
      return this.orderPackage.backofficeCode.toUpperCase()
    },
    trackingNumberYun() {
      if (!this.order.shippingLabels || !this.order.shippingLabels[0]) {
        return null;
      }

      switch (this.order.shippingMethod) {
        case "yun": {
          if (
            this.orderPackage &&
            this.orderPackage.trackingNumber &&
            this.orderPackage.trackingNumber === this.order.shippingLabels[0].shippingLabelId
          ) {
            return null;
          }
          return this.order.shippingLabels[0].shippingLabelId;
        }
        default:
          return null;
      }
    },
  },
  methods: {
    ...mapActions({
      setField: 'order/setField',
    }),
  }
};
</script>
